import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=8532f412&"
import script from "./IconArrowRight.vue?vue&type=script&lang=js&"
export * from "./IconArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports